import React, { useRef } from 'react'
import { StyleSheet } from 'aphrodite'
import { useReactToPrint } from 'react-to-print'
import Button from '../../components/common/Button'
import { useDeleteRequest } from '../../hooks/request'
import { useModal } from '../../hooks/modal'
import { domain, PRODUCT_DETAIL } from '../../urls'
import { measurement } from '../../utils/position'
import ProductUpdate from '../../components/ProductUpdate'
import { useCustomModal } from '../../hooks/customModal'
import PrintBarCode from '../../components/PrintBarCode'
import { useMessage } from '../../hooks/message'
import ComponentToPrintCode from '../../components/PrintCode'

export default function ItemProduct({
    // check,
    categoryList, item,
    // user,
    brandList, index, products
}) {
    const productRemove = useDeleteRequest({ url: PRODUCT_DETAIL.replace('{id}', item?.id) })
    // const [showDetailModal, hideDetailModal] = useModal(<ProductHistory check={check} productId={item.id} user={user} item={item} hideModal={() => hideDetailModal()} />, styles.modal)
    const [showUpdateModal, setShowUpdateModal] = useModal(<ProductUpdate products={products} categoryList={categoryList} brandList={brandList} item={item} hideModal={() => setShowUpdateModal()} />, styles.modal)

    const [showImageModal] = useCustomModal(
        item?.image ? (
            <img src={domain + item.image} alt={item.name || 'Product image'} />
        ) : (
            <div style={{
                padding: '20px',
                textAlign: 'center',
                color: '#999',
                fontSize: '16px'
            }}>
                <i className="fas fa-image" style={{ fontSize: '48px', marginBottom: '10px' }} />
                <p>📷 Изображение отсутствует.</p>

            </div>
        )
    )
    const [showMessage] = useMessage()

    async function onDelete() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            const { success, error } = await productRemove.request()
            if (success) {
                await products.request()
            } else if (error) {
                console.log(error)
                showMessage(error?.data?.error, 'is-danger')
            }
        }
    }

    // Default image placeholder
    const defaultImageStyle = {
        width: '40px',
        height: '40px',
        backgroundColor: '#f5f5f5',
        border: '1px solid #ddd',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#999',
        fontSize: '12px',
        textAlign: 'center'
    }

    const imageStyle = {
        width: '40px',
        height: '40px',
        objectFit: 'cover',
        borderRadius: '4px',
        border: '1px solid #ddd'
    }

    const componentRef = useRef()
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    })

    const codeRef = useRef()
    const handlePrintCode = useReactToPrint({
        content: () => codeRef.current,
    })
    return (
        <tr className=" is-size-6" key={item.id}>
            <td className="is-size-6">{index + 1}</td>
            <td className="is-size-6 is-capitalized">
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {item?.image ? (
                        <img
                            onClick={showImageModal}
                            src={domain + item.image}
                            alt={item.name}
                            style={imageStyle}
                        />
                    ) : (
                        <div onClick={showImageModal} style={defaultImageStyle}>
                            <ion-icon name="image-outline" />
                        </div>
                    )}
                    <span>{item?.name}</span>
                </div>
            </td>
            <td className="is-size-6">
                {item?.count ? item?.count : 0} {measurement(item?.measurement)}
            </td>
            <td className="is-size-6">{item.barcode}</td>
            <td className="is-size-6">{item?.category ? item.selectCategory.name : 'Другое'}</td>

            <td>
                <div style={{ alignItems: '' }} className="is-pulled-left">
                    <Button onClick={handlePrint} className="mr-2 button is-link is-outlined is-small"
                        icon="qr-code-outline" />
                    <div style={{ display: 'none' }}>
                        <PrintBarCode item={item} ref={componentRef} />
                    </div>
                    <Button onClick={showUpdateModal} className="mr-2 button is-success is-outlined is-small" icon="pencil-outline" />
                    <Button onClick={onDelete} className="button is-danger is-outlined is-small" icon="trash" />
                    <Button onClick={handlePrintCode} className="ml-2 button is-primary is-outlined is-small"
                        icon="barcode-outline" />
                    <div style={{ display: 'none' }}>
                        <ComponentToPrintCode item={item} ref={codeRef} />
                    </div>
                </div>
            </td>
        </tr>
    )
}

const styles = StyleSheet.create({
    tr: { ':nth-child(1n) > td': { lineHeight: 1 } },
    center: { display: 'flex', alignItems: 'center' },
    td1: { display: 'flex', alignItems: 'center', gap: '5px', lineHeight: 1, cursor: 'pointer' },
    td1Img: { width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' },
    td1Right: {},
    td1RightTitle: { fontFamily: 'GilroySemi', color: '#333333', lineHeight: '19px' },
    td1RightSubtitle: { marginTop: '1px', fontFamily: 'Gilroy', fontSize: '14px', color: 'rgba(51, 51, 51, 0.7)', lineHeight: '16px' },
    industries: { display: 'flex', whiteSpace: 'nowrap', flexWrap: 'wrap' },
    modal: { width: 1000 },
    icon: { fontSize: '20px', padding: 10 },
})
